export const formatTime = (seconds) => {
    // Handle negative numbers by using absolute value
    const absSeconds = Math.abs(seconds);
    
    const getSeconds = `0${absSeconds % 60}`.slice(-2);
    const totalMinutes = Math.floor(absSeconds / 60);
    const getMinutes = `0${totalMinutes % 60}`.slice(-2);
    const getHours = `0${Math.floor(absSeconds / 3600)}`.slice(-2);

    // If there are hours (more than 60 minutes), show HH:MM:SS format
    if (totalMinutes >= 60) {
        return `${getHours}:${getMinutes}:${getSeconds}`;
    }
    
    // Otherwise show MM:SS format for times under 60 minutes
    return `${getMinutes}:${getSeconds}`;
};
